export const toggleCart = 'toggleCart';
export const toggleGlobalLoading = 'toggleGlobalLoading';
export const setCart = 'setCart';
export const setCheckout = 'setCheckout';
export const setPaypalDetails = 'setPaypalDetails';
export const toggleHeader = 'toggleHeader';
